import { ToastContext } from './contexts';
import ProfileProvider from './profileProvider';
import toast, { toastConfig } from 'react-simple-toasts';
import ToastElement from '../Toasts/ToastElement';
import ToastsOptions from '../Toasts/ToastOptions/toastOptions';

toastConfig({
	...ToastsOptions.DefaultToastOptions,
});

function ToastProvider() {
	function enqueueToast(message, options) {
		options = checkTheme(options);
		options = setRenderProps(message, options);
		options = checkMaxVisible(options);
		options = checkPosition(options);

		return toast(message, options);
	}

	function checkTheme(options) {
		return {
			...options,
			...{ theme: ToastsOptions.ToastThemes.verifyTheme(options.theme) },
		};
	}

	function setRenderProps(message, options) {
		const renderProps = {};

		if (options?.header) {
			renderProps.header = options.header;
			delete options.header;
		}

		renderProps.theme = options.theme;

		renderProps.message = message;

		return {
			...options,
			...{ render: () => <ToastElement {...renderProps} /> },
		};
	}

	function checkMaxVisible(options) {
		if (options?.maxVisibleToasts) return options;

		return {
			...options,
			...{
				maxVisibleToasts: ToastsOptions.DefaultToastOptions.maxVisibleToasts,
			},
		};
	}

	function checkPosition(options) {
		return {
			...options,
			...{ position: ToastsOptions.verifyPosition(options.position) },
		};
	}

	return (
		<ToastContext.Provider
			value={{
				enqueueToast: enqueueToast,
			}}
		>
			<ProfileProvider />
		</ToastContext.Provider>
	);
}

export default ToastProvider;
